// extracted by mini-css-extract-plugin
module.exports = {"author":"ArticleAuthor_author__Hlcug","icon":"ArticleAuthor_icon___ax2d","name":"ArticleAuthor_name__4gn8b","position":"ArticleAuthor_position__n7yMV"};